import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { BreadcrumbsComponent } from 'swag-client-common/components/partials/breadcrumbs';
import { withConditionalRendering } from 'swag-client-common/components/utils/with-conditional-rendering';
import { hideForCBSWithLessThen12Products, hideForLimitedBuyingCartView } from 'swag-client-common/redux/cart/cart.utils';
import { breadcrumbsSelector } from '../../../../../../redux/navigation/navigation.selectors';
import { isLimitedEditionSelector } from '../../../../../../redux/product/product.selectors';
const mapStateToProps = createSelector(breadcrumbsSelector, isLimitedEditionSelector, hideForCBSWithLessThen12Products, (links, isLimitedEdition, hideForCBSWithLessThen12Products) => ({
  links,
  isLimitedEdition,
  hideForCBSWithLessThen12Products
}));
export const Breadcrumbs = withConditionalRendering(connect(mapStateToProps, null)(BreadcrumbsComponent), state => hideForLimitedBuyingCartView(state));